import React, { Fragment } from 'react';
import { Badge } from 'src/components/atoms';
import CheckboxWithLabel from 'src/components/moleculesLegacy/CheckboxWithLabel';
import { FormattedNamedOffender } from 'src/components/pages/Case/helpers/namedOffender';
import { DefaultTheme } from 'styled-components';
import { EventDetailsDescription } from './EventDetailsAccordion.styles';

interface FormatOffendersProps {
  namedOffenders: FormattedNamedOffender[];
  dataTestId: string;
  linkOffender: (
    offender: FormattedNamedOffender,
    canAddNamedOffender?: boolean,
  ) => React.ReactNode | string;
  canAddNamedOffender?: boolean;
  theme: DefaultTheme;
  checkbox?: {
    checked: (id: string) => boolean;
    onChange: (id: string) => void;
  };
}

export const formatOffenders = ({
  namedOffenders,
  dataTestId,
  linkOffender,
  canAddNamedOffender = false,
  theme,
  ...props
}: FormatOffendersProps) =>
  namedOffenders.map((offender) => {
    const linkButton = linkOffender(offender, canAddNamedOffender);
    const isPreSubmissionOffender = offender.events
      .map((event) => event.type)
      .includes('Presubmission');

    return (
      <Fragment key={offender.id}>
        {props.checkbox && (
          <EventDetailsDescription
            data-testid={`${dataTestId}-named-offenders-${offender.name}-checkbox`}
            fullWidth
          >
            <CheckboxWithLabel
              checked={props.checkbox?.checked(offender.id.toString())}
              onChange={() => props.checkbox?.onChange(offender.id.toString())}
            />
          </EventDetailsDescription>
        )}
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}`}
          fullWidth
        >
          {offender.name}
        </EventDetailsDescription>
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}-department`}
          fullWidth
        >
          {offender.department}
        </EventDetailsDescription>
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}-site`}
          fullWidth
        >
          {offender.site}
        </EventDetailsDescription>
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}-country`}
          fullWidth
        >
          {offender.country}
        </EventDetailsDescription>
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}-report-id`}
          fullWidth
        >
          {offender.reports[0].id}
        </EventDetailsDescription>
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}-added`}
          fullWidth
        >
          <Badge
            variant="custom"
            text={
              isPreSubmissionOffender ? 'Time of submission' : 'Post submission'
            }
            color={
              theme.isVaultVariant
                ? theme.newPalette.neutral.N800
                : theme.atlas.semantic.color.type.default
            }
            background-color={
              theme.isVaultVariant
                ? theme.newPalette.turquoise.T100
                : theme.atlas.semantic.color.surface.variant
            }
          />
        </EventDetailsDescription>
        <EventDetailsDescription
          data-testid={`${dataTestId}-named-offenders-${offender.name}-linked`}
          fullWidth
        >
          {!offender.external ? (
            <Badge
              variant="custom"
              text="Employee linked"
              color={
                theme.isVaultVariant
                  ? theme.newPalette.neutral.N800
                  : theme.atlas.semantic.color.type.default
              }
              background-color={
                theme.isVaultVariant
                  ? theme.newPalette.turquoise.T100
                  : theme.atlas.semantic.color.surface.variant
              }
            />
          ) : (
            linkButton
          )}
        </EventDetailsDescription>
      </Fragment>
    );
  });
